import React, { useState, useEffect, useRef, useContext, useCallback } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Select from "react-select";
import { useRouter } from "next/router";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import objectSupport from "dayjs/plugin/objectSupport";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import ContentfulBlogs from "../../../components/contentfulBlogs/ContentfulBlogs";
import { useCookies } from "react-cookie";
import Link from "next/link";
import { AiOutlineCloseCircle, AiOutlineDownload } from "react-icons/ai";

import { appServerSideProps } from "../../../utils/getAppService";

import Dropdown from "../../../components/dropdown/Dropdown";
import IconButton from "../../../components/button/IconButton";
import Content from "../../../components/layout/Content";
import ballIcon from "../../../assets/images/ball-small-icon.png";
import { AppContext } from "../../../context/state";
import { authGetRequest, authPostRequest } from "../../../utils/authGetRequest";

import Utils from "../../../utils/Utils";
import MainLayout from "../../../components/MainLayout/MainLayout";
import Image from "next/image";
import Head from "next/head";
import ScoreCard from "../../../components/ScoreCard/ScoreCard";
import ScoreCardFuturesGames from "../../../components/ScoreCardFuturesGames/ScoreCardFuturesGames";
import { Button } from "react-bootstrap";
import Input from "../../../components/form/Input";
import FreeScoreCenter from "../../../components/FreeScoreCenter";
import WinningMetrics from "../../../components/WinningMetrics";
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(objectSupport);
dayjs.extend(timezone);
dayjs.extend(utc);

const leagueOptions = [
  { value: "college_mens", label: "NCAA" },
  // { value: "college_womens", label: "NCAAW" },
  { value: "nba", label: "NBA" },
  { value: "wnba", label: "WNBA" },
];
const Scores = ({ user }) => {
  const [loading, setLoading] = useState(true);
  const [authToken, setAuthToken] = useState(null);
  const router = useRouter();
  let leagueFromUrl = router.query.league;
  let tempLeagueType = null;
  if (leagueFromUrl === "ncaa") tempLeagueType = { value: "college_mens", label: "NCAA" };
  if (leagueFromUrl === "ncaaw") tempLeagueType = { value: "college_womens", label: "NCAAW" };
  if (leagueFromUrl === "nba") tempLeagueType = { value: "nba", label: "NBA" };
  if (leagueFromUrl === "japan_b1") tempLeagueType = { value: "japan_b1", label: "Japan B1" };
  if (leagueFromUrl === "wnba") tempLeagueType = { value: "wnba", label: "WNBA" };

  useEffect(() => {
    if (document.cookie.includes("token_access=")) {
      setAuthToken(document.cookie.split("token_access=").pop().split(";").shift());
    }
  }, []);
  const [selectedLeagueType, setSelectedLeagueType] = useState(tempLeagueType);
  const { store, setStore } = useContext(AppContext);
  const { headerLeagueGames } = store;
  const [cookies, setCookie] = useCookies(["token_access, name"]);
  const [conferences, setConferences] = useState([]);
  const [conference, setConference] = useState(null);
  const [activeDate, setActiveDate] = useState(dayjs());
  const isToday = activeDate.startOf("day").isSame(dayjs().startOf("day"));
  const todaysDateNYC = dayjs.utc().tz("America/New_York").format("YYYY-MM-DD");
  const yesterdayDateNYC = dayjs.utc().tz("America/New_York").subtract(1, "day").format("YYYY-MM-DD");
  const [isBeforeFiveDays, setIsBeforeFiveDays] = useState(false);
  // const yesterdayDateNYC = dayjs().subtract(1, "day").format("YYYY-MM-DD");
  const [showCSVDropdown, setShowCSVDropdown] = useState(false);
  const exportCSVRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [filteredTeamData, setFilteredTeamData] = useState([]);
  const [gamesData, setGamesData] = useState([]);
  const searchInputRef = useRef(null);
  const [searchKey, setSearchKey] = useState("");

  const isStandardPlan = Utils.hasStandardPlan(user);
  const isPremiumPlan = Utils.hasPremiumPlan(user) || Utils.isTrader(user);
  const isTrader = Utils.isTrader(user);
  const isPaidPlan = isStandardPlan || isPremiumPlan;
  const [headerGames, setHeaderGames] = useState([]);
  const [liveGames, setLiveGames] = useState([]);
  const [todaysHeaderGames, setTodaysHeaderGames] = useState([]);
  const [pastGames, setPastGames] = useState([]);
  const [futureGames, setFutureGames] = useState([]);
  const [gamesType, setGamesType] = useState("Future");

  const [myScoreCenter, setMyScoreCenter] = useState([]);
  const [showMyScoreCenter, setShowMyScoreCenter] = useState(false);
  const [myFutureGames, setMyFutureGames] = useState([]);
  const [myPastGames, setMyPastGames] = useState([]);
  const [myLiveGames, setMyLiveGames] = useState([]);
  const [withFutureGames, setWithFutureGames] = useState([]);
  const today = dayjs();
  const fiveDaysAgo = today.subtract(7, "day");
  const [selectedDate, setSelectedDate] = React.useState(dayjs());

  useEffect(() => {
    let withFutureGamesTemp = [];
    if (headerLeagueGames && selectedLeagueType.value) {
      const withoutFutureGames = headerLeagueGames[selectedLeagueType.value].filter(
        (game) => game.status !== "future" && game.status !== "scheduled"
      );
      setHeaderGames(withoutFutureGames);
      setWithFutureGames(headerLeagueGames[selectedLeagueType.value]);
      withFutureGamesTemp = headerLeagueGames[selectedLeagueType.value];
    }
    const formattedDate = dayjs(activeDate).format("YYYY-MM-DD");
    if (dayjs().format("YYYY-MM-DD") === formattedDate) {
      const todaysGameScheduled = withFutureGamesTemp
        .filter((game) => {
          return (
            game.game_time_nyc.includes(formattedDate) && (game.status === "scheduled" || game.status === "future")
          );
        })
        .map((game) => {
          return {
            ...game,
            id: game.game_id,
            date: game.game_time_nyc,
            time: game.game_time_nyc.split(" ")[1] + " ",
            status: "scheduled",
            projected_opp_score: game.projected_away_score,
            projected_score: game.projected_home_score,
          };
        });
      setFutureGames(todaysGameScheduled);
    } else setFutureGames([]);
  }, [headerLeagueGames, selectedLeagueType?.value]);
  useEffect(() => {
    if (headerGames) {
      headerGames.forEach((game) => {
        if (game.conference === null) {
          game.conference = game.home_conference;
        }
      });
      const liveHeaderGames = headerGames.filter((game) => game.status === "live");
      const todaysHeaderGames = headerGames.filter((game) => game.game_time_nyc.includes(todaysDateNYC));
      setTodaysHeaderGames(todaysHeaderGames);
      setLiveGames(liveHeaderGames);
    }
  }, [headerGames, todaysDateNYC]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (exportCSVRef.current && !exportCSVRef.current.contains(event.target)) {
      setShowCSVDropdown(false);
    }
  };
  useEffect(() => {
    setStore({ ...store, leagueType: selectedLeagueType.value });
  }, [selectedLeagueType.value]);

  const clearSearch = (e) => {
    setSearchKey("");
    setFilteredTeamData([]);
    searchInputRef.current.value = "";
  };

  const fullSeasonDownloadLinkRef = useCallback(
    (ref) => {
      if (!isPaidPlan || !user?.has_paid) {
        alert("Please upgrade to a paid plan to access this feature");
        return;
      }
      if (ref !== null && user !== null && authToken !== null) {
        fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/${selectedLeagueType.value}/past-games/download-csv`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        })
          .then((resp) => resp.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = "Full_Season.csv";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(async (err) => {
            console.error(err);
          });
      }
    },
    [user, authToken, selectedLeagueType.value]
  );

  const handleCSVExport = (e) => {
    if (!isPaidPlan || !user?.has_paid) {
      alert("Please upgrade to a paid plan to access this feature");
      return;
    }
    const csvType = e.target.getAttribute("type");
    switch (csvType) {
      case "tonight":
        const games = [...filteredTeamData].map((gm) => {
          return {
            ...gm,
            Game_ID: "",
          };
        });

        Utils.jsonToCsv(games);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    setLoading(true);
    if (authToken && user && isPaidPlan && user?.has_paid) {
      if (
        dayjs(activeDate).isSameOrAfter(dayjs()) ||
        dayjs(activeDate).isSame(dayjs()) ||
        dayjs().format("MM-DD-YYYY") === dayjs(activeDate).format("MM-DD-YYYY")
      ) {
        const activeDay = activeDate.date();
        authGetRequest(
          `/api/${selectedLeagueType.value}/scores/future-games/${activeDate.year()}/${
            activeDate.month() + 1
          }/${activeDate.date()}`,

          authToken
        )
          .then((response) => response?.data)
          .then((response) => {
            if (response?.data?.length) {
              let arrayWithIds = response.data.map((item, index) => {
                return {
                  ...item,
                  id: activeDay + "" + index,
                  status: "scheduled",
                };
              });
              setFutureGames(arrayWithIds);
            } else {
              const formattedDate = dayjs(activeDate).format("YYYY-MM-DD");
              if (dayjs().format("YYYY-MM-DD") === formattedDate) {
                const todaysGameScheduled = withFutureGames
                  .filter(
                    (game) =>
                      game?.game_time_nyc?.includes(formattedDate) &&
                      (game.status === "scheduled" || game.status === "future")
                  )
                  .map((game) => {
                    return {
                      ...game,
                      id: game?.game_id,
                      date: game?.game_time_nyc,
                      time: game?.game_time_nyc?.split(" ")[1] + " ",
                      status: "scheduled",
                      projected_opp_score: game?.projected_away_score,
                      projected_score: game?.projected_home_score,
                    };
                  });
                setFutureGames(todaysGameScheduled);
              } else setFutureGames([]);
            }
            // return response.data
          })
          .catch(async (err) => {
            if (err.message.includes("401") && isPremiumPlan) {
              try {
                const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${authToken}`,
                  },
                  body: authToken,
                })
                  .then((res) => res.json())
                  .then((response) => {
                    if (response.access_token) {
                      setCookie("token_access", response.access_token);
                      setAuthToken(response.access_token);
                    }
                  });
              } catch (error) {
                console.error(error);
              }
            }
            console.error(err);
          })
          .finally(() => {
            setTimeout(() => {
              setLoading(false);
            }, 1500);
          });
      } else {
        authGetRequest(
          `/api/${selectedLeagueType.value}/scores/past-games/${activeDate.year()}/${
            activeDate.month() + 1
          }/${activeDate.date()}`,
          authToken
        )
          .then((response) => response?.data)
          .then((response) => {
            if (response?.data?.length) {
              const tempGameIdArray = [];
              const tempPastGames = response.data.filter((item) => {
                if (
                  !tempGameIdArray.includes(item.game_id) &&
                  (item.location === "home" || item.location === "neutral")
                ) {
                  tempGameIdArray.push(item.game_id);
                  return true;
                }
                return false;
              });
              setPastGames(tempPastGames);
            } else {
              setPastGames([]);
            }
          })
          .catch(async (err) => {
            if (err.message.includes("401") && isPremiumPlan) {
              try {
                const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                  method: "POST",
                  headers: {
                    Authorization: `Bearer ${authToken}`,
                  },
                  body: authToken,
                })
                  .then((res) => res.json())
                  .then((response) => {
                    if (response.access_token) {
                      setCookie("token_access", response.access_token);
                      setAuthToken(response.access_token);
                    }
                  });
              } catch (error) {
                console.error(error);
              }
            }
            console.error(err);
          })
          .finally(() => {
            setTimeout(() => {
              setLoading(false);
            }, 1500);
          });
      }
    } else {
      setLoading(false);
    }
  }, [activeDate, authToken, selectedLeagueType.value]);

  const toggleModal = () => {
    setOpenModal(!openModal);
  };

  function getConferences(games) {
    let conferences = games.map((game) => game.conference);
    conferences = ["All conferences", ...new Set(conferences)].map((conference) => {
      return { value: conference, sort: conference, label: conference };
    });
    return conferences;
  }

  const handleDateChange = (date) => {
    let tempDate = dayjs(date);
    let isToday = tempDate.startOf("day").isSame(dayjs().startOf("day"));
    setSelectedDate(date);
    setActiveDate(tempDate);
    if (!isToday) {
      setConference(null);
      setFILTER_TYPE("ALL");
    }
  };
  let nbaLiveGame = "";
  let ncaaLiveGame = "";
  nbaLiveGame = liveGames?.find((game) => game.leagueType === "nba" && game.live_free === 1);
  ncaaLiveGame = liveGames?.find(
    (game) => (game.leagueType === "college_mens" || game.leagueType === "ncaa") && game.live_free === 1
  );
  // if there is no live game, show future games
  if (!nbaLiveGame) {
    nbaLiveGame = withFutureGames?.find(
      (game) =>
        game.leagueType === "nba" && game.live_free === 1 && (game.status === "future" || game.status === "scheduled")
    );
    if (nbaLiveGame) {
      nbaLiveGame = {
        ...nbaLiveGame,
        projected_opp_score: nbaLiveGame.projected_away_score,
        projected_score: nbaLiveGame.projected_home_score,
      };
    }
  }
  if (!nbaLiveGame) {
    //wnba
    nbaLiveGame = liveGames?.find((game) => game.leagueType === "wnba" && game.live_free === 1);
    if (!nbaLiveGame) {
      nbaLiveGame = withFutureGames?.find(
        (game) =>
          game.leagueType === "wnba" &&
          game.live_free === 1 &&
          (game.status === "future" || game.status === "scheduled")
      );
      if (nbaLiveGame) {
        nbaLiveGame = {
          ...nbaLiveGame,
          projected_opp_score: nbaLiveGame.projected_away_score,
          projected_score: nbaLiveGame.projected_home_score,
        };
      }
    }
  }
  if (!ncaaLiveGame) {
    ncaaLiveGame = withFutureGames?.find(
      (game) =>
        (game.leagueType === "college_mens" || game.leagueType === "ncaa") &&
        game.live_free === 1 &&
        (game.status === "future" || game.status === "scheduled")
    );
    if (ncaaLiveGame) {
      ncaaLiveGame = {
        ...ncaaLiveGame,
        projected_opp_score: ncaaLiveGame.projected_away_score,
        projected_score: ncaaLiveGame.projected_home_score,
      };
    }
  }

  useEffect(() => {
    const today = dayjs().startOf("day"); // Set time to the start of today (midnight)
    const activeDateStart = activeDate.startOf("day"); // Set time of activeDate to the start of that day

    if (activeDateStart.isBefore(today)) {
      setGamesData(pastGames);
      setConferences(getConferences(pastGames));
      setGamesType("past");
    }
    if (activeDateStart.isAfter(today)) {
      setGamesData(futureGames);
      setConferences(getConferences(futureGames));
      setGamesType("future");
    }
    if (activeDateStart.isSame(today)) {
      setConferences(getConferences([...todaysHeaderGames, ...futureGames]));
      setGamesData([...todaysHeaderGames, ...futureGames]);
      setGamesType("live");
    }
  }, [activeDate, pastGames, futureGames, todaysHeaderGames]);
  useEffect(() => {
    if (activeDate.isBefore(today.subtract(6, "day"))) {
      setIsBeforeFiveDays(true);
    } else {
      setIsBeforeFiveDays(false);
    }
  }, [activeDate]);

  useEffect(() => {
    const searchGame = (searchKey) => {
      searchKey = searchKey.trim();
      if (!searchKey || typeof searchKey !== "string") {
        console.error("Invalid search key");
        return [];
      }

      return gamesData.filter((game) => {
        const homeTeam = game?.home ? game.home.toLowerCase().includes(searchKey.toLowerCase()) : false;
        const awayTeam = game?.away ? game.away.toLowerCase().includes(searchKey.toLowerCase()) : false;
        const team = game?.team ? game.team.toLowerCase().includes(searchKey.toLowerCase()) : false;
        const opponent = game?.opponent ? game.opponent.toLowerCase().includes(searchKey.toLowerCase()) : false;

        return homeTeam || awayTeam || team || opponent;
      });
    };
    if (searchKey.length > 0) {
      const filteredData = searchGame(searchKey);

      setFilteredTeamData(filteredData);
      setConference(null);
    } else {
      setFilteredTeamData(gamesData);
    }
  }, [searchKey, gamesData, gamesType]);

  useEffect(() => {
    if (authToken) {
      authGetRequest(`/api/extras/my_score_center`, authToken)
        .then((response) => response.data)
        .then((response) => {
          if (response?.data) {
            setMyScoreCenter(JSON.parse(response.data));
          }
        })
        .catch(async (err) => {
          console.error(err);
        });
    }
  }, [authToken]);

  const updateMyScoreCenter = (value) => {
    let tempMyScoreCenter = [...myScoreCenter];
    if (tempMyScoreCenter.includes(value) === false) {
      tempMyScoreCenter = [...myScoreCenter, value];
    } else {
      tempMyScoreCenter = myScoreCenter.filter((item) => item !== value);
    }
    authPostRequest(`/api/extras/my_score_center`, authToken, {
      my_score_center: JSON.stringify(tempMyScoreCenter),
    })
      .then((response) => response.data)
      .then((response) => {
        setMyScoreCenter(JSON.parse(response.data));
      })
      .catch(async (err) => {
        console.error(err);
      });
  };
  useEffect(() => {
    if (user && showMyScoreCenter && myScoreCenter.length > 0) {
      let dateArray = myScoreCenter.map((item) => {
        let rawDate = item.split("/")[1];
        let formattedDate = dayjs(rawDate).format("YYYY-MM-DD");
        return formattedDate;
      });
      let uniqueDates = [...new Set(dateArray)];
      let futureDates = uniqueDates.filter(
        (date) =>
          dayjs(date).isSameOrAfter(dayjs()) ||
          dayjs(date).isSame(dayjs()) ||
          dayjs().format("MM-DD-YYYY") === dayjs(date).format("MM-DD-YYYY")
      );
      let pastDates = uniqueDates.filter(
        (date) => dayjs(date).isBefore(dayjs()) && dayjs().format("MM-DD-YYYY") !== dayjs(date).format("MM-DD-YYYY")
      );

      const futureGamesPromises = futureDates.map((date) => {
        return authGetRequest(
          `/api/${selectedLeagueType.value}/scores/future-games/${date.replaceAll("-", "/")}`,
          authToken
        )
          .then((response) => response.data)
          .then((response) => {
            if (response?.data?.length) {
              let arrayWithIds = response.data.map((item, index) => {
                return {
                  ...item,
                  id: "myScoreCenter" + date + index,
                };
              });
              return arrayWithIds;
            } else {
              return [];
            }
          })
          .catch(async (err) => {
            console.error(err);
            return [];
          });
      });

      Promise.all(futureGamesPromises)
        .then((results) => {
          const futureGamesData = results.flat();
          const selectedGames = futureGamesData.filter((gm) =>
            myScoreCenter.includes(gm.team + gm.opponent + "/" + dayjs(gm.date).format("YYYY-MM-DD"))
          );
          setMyFutureGames(selectedGames);
        })
        .catch((err) => {
          console.error(err);
        });
      const pastGamesPromises = pastDates.map((date) => {
        return authGetRequest(
          `/api/${selectedLeagueType.value}/scores/past-games/${date.replaceAll("-", "/")}`,
          authToken
        )
          .then((response) => response.data)
          .then((response) => {
            if (response?.data?.length) {
              const tempGameIdArray = [];
              const filteredGames = response.data.filter((item) => {
                if (
                  !tempGameIdArray.includes(item.game_id) &&
                  (item.location === "home" || item.location === "neutral")
                ) {
                  tempGameIdArray.push(item.game_id);
                  return true;
                }
                return false;
              });

              // const filteredGames = response.data.filter((gm) => gm.location === "home");
              return filteredGames;
            } else {
              return [];
            }
          })
          .catch(async (err) => {
            console.error(err);
            return [];
          });
      });

      Promise.all(pastGamesPromises)
        .then((results) => {
          const pastGamesData = results.flat();
          const selectedGames = pastGamesData.filter((gm) =>
            myScoreCenter.includes(gm.team + gm.opponent + "/" + dayjs(gm.date).format("YYYY-MM-DD"))
          );
          setMyPastGames(selectedGames);
        })
        .catch((err) => {
          console.error(err);
        });

      const myLiveGames = liveGames.filter((gm) =>
        myScoreCenter.includes(gm.team + gm.opponent + "/" + dayjs(gm.game_time_nyc).format("YYYY-MM-DD"))
      );
      setMyLiveGames(myLiveGames);
    }
  }, [activeDate, showMyScoreCenter]);

  //filter games by status and set color of button active upon click
  const [FILTER_TYPE, setFILTER_TYPE] = useState("ALL");
  useEffect(() => {
    if (localStorage.getItem("FILTER_TYPE")) {
      setFILTER_TYPE(localStorage.getItem("FILTER_TYPE"));
    }
  }, []);
  useEffect(() => {
    localStorage.setItem("FILTER_TYPE", FILTER_TYPE);
    switch (FILTER_TYPE) {
      case "ALL":
        setGamesData([...todaysHeaderGames, ...futureGames]);
        setConferences(getConferences([...todaysHeaderGames, ...futureGames]));
        break;
      case "LIVE":
        setGamesData(liveGames);
        setConferences(getConferences([...liveGames]));
        break;
      case "Halftime":
        setGamesData(liveGames);
        setConferences(getConferences([...liveGames]));
        break;
      case "FINAL":
        setGamesData(todaysHeaderGames.filter((game) => game.status === "final"));
        setConferences(getConferences(todaysHeaderGames.filter((game) => game.status === "final")));
        break;
      case "FUTURE":
        setGamesData([...todaysHeaderGames.filter((game) => game.status === "scheduled"), ...futureGames]);
        setConferences(
          getConferences([...todaysHeaderGames.filter((game) => game.status === "scheduled"), ...futureGames])
        );
        break;
      default:
        setGamesData([...todaysHeaderGames, ...futureGames]);
        setConferences(getConferences([...todaysHeaderGames, ...futureGames]));

        break;
    }
  }, [FILTER_TYPE, todaysHeaderGames, futureGames, liveGames]);

  const updateFilter = ({ type }) => {
    setFILTER_TYPE(type);
    setConference(null);
  };

  const gameCardListRef = useRef(null);
  const [numberOfHalfTimeCards, setNumberOfHalfTimeCards] = useState(0);

  useEffect(() => {
    const countCards = () => {
      const container = gameCardListRef.current;
      if (container instanceof HTMLElement) {
        // Check if container is a valid DOM node
        const cards = container.querySelectorAll(".gameCard");
        setNumberOfHalfTimeCards(cards.length);
      }
    };

    countCards(); // Call countCards initially

    const observer = new MutationObserver(countCards);
    const container = gameCardListRef.current;

    if (container instanceof HTMLElement) {
      // Check if container is a valid DOM node
      observer.observe(container, { childList: true }); // Pass container to observe method
    }

    return () => {
      observer.disconnect();
    };
  }, []);
  return (
    <>
      <Head>
        <title>{`${selectedLeagueType?.label} ScoreCenter, Live ShotQuality Scores | ShotQualityBets`}</title>
        <meta
          property="description"
          content={`Your home for halftime. See live regression data for today's ${selectedLeagueType?.label} games to power your live picks and predictions.`}
        />
      </Head>

      <MainLayout>
        {(!isPaidPlan || !user?.has_paid) && futureGames.length <= 0 ? (
          <>
            <FreeScoreCenter
              nbaLiveGame={nbaLiveGame}
              ncaaLiveGame={ncaaLiveGame}
              store={store}
              user={user}
              isStandardPlan={isStandardPlan}
              isPremiumPlan={isPremiumPlan}
              leagueFromUrl={leagueFromUrl}
            />
          </>
        ) : (
          <Content className="Scoreside" id="ContentBox" myId="ScoreCenter" style={{ minHeight: "100vh" }}>
            <div className="row ml-1 mr-1 pt-5">
              <div className="col-6 col-sm-6 col-md-2 mb-2">
                <Select
                  instanceId="league-dropdown-shotquality-scores"
                  id={"league-dropdown-shotquality-scores"}
                  options={leagueOptions}
                  placeholder="Select League"
                  value={selectedLeagueType}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      padding: "8px",
                    }),
                  }}
                  onChange={(e) => {
                    setConference(null);
                    setSelectedLeagueType(e);
                    window.history.replaceState(null, null, `/${e.label.toLowerCase()}/shotquality-scores`);
                  }}
                />
              </div>
              <div className="col-6 col-sm-6 col-md-2 mb-2">
                {isPremiumPlan ? (
                  <LocalizationProvider dateAdapter={AdapterDayjs} className="w-100">
                    <DatePicker
                      className="w-100"
                      value={selectedDate}
                      onChange={handleDateChange}
                      open={openModal}
                      onOpen={toggleModal}
                      onClose={toggleModal}
                      textField={(params) => <input {...params} />} // eslint-disable-line react/jsx-props-no-spreading
                    />
                  </LocalizationProvider>
                ) : (
                  <LocalizationProvider dateAdapter={AdapterDayjs} className="w-100">
                    <DatePicker
                      className="w-100"
                      value={selectedDate}
                      onChange={handleDateChange}
                      // open={openModal}
                      open={isPaidPlan || user?.has_paid ? openModal : false}
                      onOpen={toggleModal}
                      onClose={toggleModal}
                      minDate={fiveDaysAgo}
                      textField={(params) => <input {...params} />}
                    />
                  </LocalizationProvider>
                )}
              </div>
              <div className="col-12 col-sm-12 col-md-2 text-md-right search-box mb-2">
                <Input
                  icon={""}
                  placeholder="🔍 Search Games"
                  className="form-control w-100 search-input search-input-scores"
                  style={{ padding: "1.6rem" }}
                  onChange={(e) => setSearchKey(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      setSearchKey(e.target.value);
                    }
                  }}
                  rightIcon={
                    searchInputRef?.current?.value.length > 0 ? <AiOutlineCloseCircle onClick={clearSearch} /> : null
                  }
                  ref={searchInputRef}
                />
              </div>
              <div className="col-6 col-sm-6 col-md-2 mb-2">
                <Select
                  instanceId="conference-dropdown-shotquality-scores"
                  id={"conference-dropdown-shotquality-scores"}
                  options={conferences}
                  placeholder="All conferences"
                  value={{
                    value: conference,
                    label: conference ? conference : "All conferences",
                  }}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      padding: "8px",
                    }),
                  }}
                  onChange={(e) => {
                    if (e.value === "All conferences") {
                      setConference(null);
                      setFilteredTeamData(gamesData);
                      return;
                    }
                    setConference(e.value);
                    const filteredData = gamesData.filter((game) => {
                      return game.conference === e.value;
                    });
                    setFilteredTeamData(filteredData);
                  }}
                />
              </div>
              <div className="col-6 col-sm-6 col-md-2 mb-2">
                <div className="btnWrapp w-100">
                  <Dropdown
                    className="w-100"
                    onMouseEnter={() => setShowCSVDropdown(true)}
                    onMouseLeave={() => setShowCSVDropdown(false)}
                  >
                    <Dropdown.Header style={{ padding: "0", minWidth: "100%" }} className="dropDown b  order-0 w-100">
                      {/* {authToken && user && isPremiumPlan ? ( */}
                      <IconButton.NoButton
                        ref={exportCSVRef}
                        icon={<AiOutlineDownload />}
                        className="latestGameBtn text-center w-100"
                        style={{ marginBottom: "0", padding: "16px 8px" }}
                      >
                        Export to CSV
                      </IconButton.NoButton>
                      {/* ) : null} */}
                    </Dropdown.Header>
                    <Dropdown.Menu
                      style={{ display: showCSVDropdown ? "grid" : "none" }}
                      className="text-center"
                      ref={exportCSVRef}
                    >
                      <Dropdown.Item type="full">
                        <a download={"full-season.csv"} onClick={fullSeasonDownloadLinkRef} style={{ unset: "all" }}>
                          Full Season
                        </a>
                      </Dropdown.Item>
                      <Dropdown.Item onClick={handleCSVExport} type="tonight">
                        Tonight&apos;s Games
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-2 mb-2">
                <button
                  onClick={() => setShowMyScoreCenter(!showMyScoreCenter)}
                  className={`btn ${showMyScoreCenter ? "btn-primary" : "btn-secondary"} w-100 p-3`}
                >
                  {showMyScoreCenter ? "All Games" : "My ScoreCenter"}
                </button>
              </div>
            </div>
            <div className="pl-4 pr-4">
              <hr />
            </div>
            <Content.Body>
              {showMyScoreCenter ? (
                <div className="row align-items-center justify-content-center">
                  <h2 style={{ color: "#f26b0b" }}>My ScoreCenter</h2>
                </div>
              ) : (
                <div className=" pl-3 row">
                  {/* set background color of button active upon click */}
                  {isToday && (
                    <>
                      <div className="col-12 text-center">
                        <Button
                          onClick={() => updateFilter({ type: "ALL" })}
                          style={{
                            backgroundColor: FILTER_TYPE === "ALL" ? "#f26b0b" : "transparent",
                            color: FILTER_TYPE === "ALL" ? "white" : "black",
                            margin: "2px",
                          }}
                          disabled={!isPaidPlan || !user?.has_paid}
                        >
                          All Games
                        </Button>
                        <Button
                          onClick={() => updateFilter({ type: "LIVE" })}
                          style={{
                            backgroundColor: FILTER_TYPE === "LIVE" ? "#f26b0b" : "transparent",
                            color: FILTER_TYPE === "LIVE" ? "white" : "black",
                            margin: "2px",
                          }}
                          disabled={!isPaidPlan || !user?.has_paid}
                        >
                          Live
                        </Button>
                        <Button
                          onClick={() => updateFilter({ type: "Halftime" })}
                          style={{
                            backgroundColor: FILTER_TYPE === "Halftime" ? "#f26b0b" : "transparent",
                            color: FILTER_TYPE === "Halftime" ? "white" : "black",
                            margin: "2px",
                          }}
                          disabled={!isPaidPlan || !user?.has_paid}
                        >
                          Halftime
                        </Button>
                        <Button
                          onClick={() => updateFilter({ type: "FINAL" })}
                          style={{
                            backgroundColor: FILTER_TYPE === "FINAL" ? "#f26b0b" : "transparent",
                            color: FILTER_TYPE === "FINAL" ? "white" : "black",
                            margin: "2px",
                          }}
                          disabled={!isPaidPlan || !user?.has_paid}
                        >
                          Final
                        </Button>
                        <Button
                          onClick={() => updateFilter({ type: "FUTURE" })}
                          style={{
                            backgroundColor: FILTER_TYPE === "FUTURE" ? "#f26b0b" : "transparent",
                            color: FILTER_TYPE === "FUTURE" ? "white" : "black",
                            margin: "2px",
                          }}
                          disabled={!isPaidPlan || !user?.has_paid}
                        >
                          Scheduled
                        </Button>
                      </div>
                      <div className="col-12 text-center">
                        <h5 className="pt-3">
                          Games : {FILTER_TYPE === "Halftime" ? numberOfHalfTimeCards : gamesData.length}
                        </h5>
                      </div>
                    </>
                  )}
                </div>
              )}
              {loading ? (
                <div className="loader-container">
                  <Image
                    height={150}
                    width={150}
                    style={{ width: "auto" }}
                    src={`/android-chrome-512x512.png`}
                    alt="Loading"
                  />
                </div>
              ) : (
                <div className="p-3">
                  {searchKey.length > 0 && filteredTeamData.length === 0 ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <h1>No Search Results </h1>
                      <div>
                        {" "}
                        <IconButton className="latestGameBtn text-center" onClick={clearSearch} style={{ margin: "0" }}>
                          Clear Search
                        </IconButton>
                      </div>
                    </div>
                  ) : null}
                  <div className="gameCardList" ref={gameCardListRef}>
                    {gamesData && gamesData.length > 0 && !showMyScoreCenter ? (
                      (filteredTeamData ? filteredTeamData : gamesData).map((card, i) => {
                        if (gamesType === "live") {
                          if (card.status === "scheduled" || card.status === "future") {
                            return (
                              <ScoreCardFuturesGames
                                key={card.id}
                                card={card}
                                isStandardPlan={isStandardPlan}
                                isPremiumPlan={isPremiumPlan}
                                user={user}
                                updateMyScoreCenter={updateMyScoreCenter}
                                myScoreCenter={myScoreCenter}
                                isToday={true}
                                leagueType={selectedLeagueType?.label?.toLowerCase()}
                              />
                            );
                          } else if (isPaidPlan || user?.has_paid) {
                            return (
                              <ScoreCard
                                isToday={true}
                                key={card.game_id}
                                data={card}
                                store={store}
                                isStandardPlan={isStandardPlan}
                                isPremiumPlan={isPremiumPlan}
                                user={user}
                                leagueFromUrl={selectedLeagueType.value}
                                updateMyScoreCenter={updateMyScoreCenter}
                                myScoreCenter={myScoreCenter}
                                showOnlyHalftime={FILTER_TYPE === "Halftime"}
                                isBeforeFiveDays={isBeforeFiveDays}
                              />
                            );
                          } else return null;
                        }
                        if (gamesType === "past" && (isPaidPlan || user?.has_paid)) {
                          if (card?.sq_score || selectedLeagueType.value === "japan_b1") {
                            return (
                              <ScoreCard
                                isLive={false}
                                key={card.game_id}
                                data={card}
                                store={store}
                                isStandardPlan={isStandardPlan}
                                isPremiumPlan={isPremiumPlan}
                                user={user}
                                leagueFromUrl={selectedLeagueType.value}
                                updateMyScoreCenter={updateMyScoreCenter}
                                myScoreCenter={myScoreCenter}
                                isJapanLeague={selectedLeagueType.value === "japan_b1" && !card?.sq_score}
                                isBeforeFiveDays={isBeforeFiveDays}
                              />
                            );
                          }
                        }
                        if (gamesType === "future") {
                          // if (card?.projected_score || selectedLeagueType.value === "wnba") {
                          return (
                            <ScoreCardFuturesGames
                              key={card.id}
                              card={card}
                              isStandardPlan={isStandardPlan}
                              isPremiumPlan={isPremiumPlan}
                              user={user}
                              updateMyScoreCenter={updateMyScoreCenter}
                              myScoreCenter={myScoreCenter}
                              leagueType={selectedLeagueType?.label?.toLowerCase()}
                            />
                          );
                          // }
                        }
                      })
                    ) : gamesData && gamesData.length > 0 && showMyScoreCenter ? (
                      <div>
                        <div className="row align-items-center justify-content-center flex-column">
                          {myLiveGames.length > 0 && (
                            <>
                              <h2 className="text-center p-4">Live Games</h2>
                              <div className="gameCardList">
                                {myLiveGames.map((card, i) => {
                                  return (
                                    <ScoreCard
                                      isToday={true}
                                      isLive={true}
                                      key={card.game_id}
                                      data={card}
                                      store={store}
                                      isStandardPlan={isStandardPlan}
                                      isPremiumPlan={isPremiumPlan}
                                      user={user}
                                      leagueFromUrl={selectedLeagueType.value}
                                      updateMyScoreCenter={updateMyScoreCenter}
                                      myScoreCenter={myScoreCenter}
                                      isBeforeFiveDays={isBeforeFiveDays}
                                    />
                                  );
                                })}
                              </div>
                            </>
                          )}
                          {myFutureGames.length > 0 && (
                            <>
                              <h2 className="text-center p-4">Future Games</h2>
                              <div className="gameCardList">
                                {myFutureGames.map((card, i) => {
                                  // if (card?.projected_score || selectedLeagueType.value === "wnba") {
                                  return (
                                    <ScoreCardFuturesGames
                                      key={card.id}
                                      card={card}
                                      isStandardPlan={isStandardPlan}
                                      isPremiumPlan={isPremiumPlan}
                                      user={user}
                                      updateMyScoreCenter={updateMyScoreCenter}
                                      myScoreCenter={myScoreCenter}
                                      leagueType={selectedLeagueType?.label?.toLowerCase()}
                                    />
                                  );
                                  // }
                                })}
                              </div>
                            </>
                          )}
                          {myPastGames.length > 0 && (
                            <>
                              <h2 className="text-center p-4">Past Games</h2>
                              <div className="gameCardList">
                                {myPastGames.map((card, i) => {
                                  if (card?.sq_score) {
                                    return (
                                      <ScoreCard
                                        isLive={false}
                                        key={card.game_id}
                                        data={card}
                                        store={store}
                                        isStandardPlan={isStandardPlan}
                                        isPremiumPlan={isPremiumPlan}
                                        user={user}
                                        leagueFromUrl={selectedLeagueType.value}
                                        updateMyScoreCenter={updateMyScoreCenter}
                                        myScoreCenter={myScoreCenter}
                                        isBeforeFiveDays={isBeforeFiveDays}
                                      />
                                    );
                                  }
                                })}
                              </div>
                            </>
                          )}
                        </div>
                        {myLiveGames.length === 0 && myFutureGames.length === 0 && myPastGames.length === 0 ? (
                          <div className="row">
                            <div className="scores-games-not-found">
                              <Image height={34} width={34} src={ballIcon} alt="" />
                              <p className="scores-games-not-found-title">No Games Found</p>
                              <p>Please try selecting different date or switching league</p>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ) : (
                      !loading && (
                        <div className="scores-games-not-found">
                          <Image height={34} width={34} src={ballIcon} alt="" />
                          {yesterdayDateNYC === activeDate.format("YYYY-MM-DD") ? (
                            <>
                              <p className="scores-games-not-found-title">Games are Processing 🤖 </p>
                              <p>Please check back soon to see Score Summaries.</p>
                            </>
                          ) : (
                            <>
                              <p className="scores-games-not-found-title">No Games Found</p>
                              <p>Please try selecting different date or switching league</p>
                            </>
                          )}
                        </div>
                      )
                    )}
                    {FILTER_TYPE === "Halftime" && numberOfHalfTimeCards == 0 && gamesData.length > 0 ? (
                      <div className="scores-games-not-found">
                        <Image height={34} width={34} src={ballIcon} alt="" />
                        <p className="scores-games-not-found-title">No Games Found</p>
                        <p>Please try selecting different date or switching league</p>
                      </div>
                    ) : null}
                  </div>
                </div>
              )}
            </Content.Body>

            {!isTrader && (
              <>
                <hr className="mt-5" />
                <Link
                  href="/betcast"
                  passHref
                  className=" is-hover d-block text-center is-link text-black"
                  style={{ fontSize: "1.4rem", fontWeight: "700" }}
                >
                  Tune in to <span className="color-orange">BetCast</span> - The only live betting show using in-game
                  regression data
                </Link>
              </>
            )}
            <hr />
          </Content>
        )}

        {leagueFromUrl === "ncaa" && (
          <div className="container">
            <ContentfulBlogs user={user} tag="marchMadness" />
          </div>
        )}
        <WinningMetrics targetPage={"Scores"} />
      </MainLayout>
    </>
  );
};

export default Scores;

export const getServerSideProps = appServerSideProps(async ({ appService }) => {
  const isUserLogged = appService.getUser();

  let user = null;

  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  return { props: { user } };
});
